import { ServiceClient } from 'src/utils'
import { ResultadoAnalise } from '../bordero/bordero.types'
import { MonitoramentoRow, RetornoEnvioVisaoCedente } from './integracao-monitoramento.types'

const serviceClient = ServiceClient.singleton()

export class IntegracaoMonitoramentoService {
    static #INSTANCE = new IntegracaoMonitoramentoService()
    static readonly singleton = () => IntegracaoMonitoramentoService.#INSTANCE

    async fetchMonitoramentoInfo(id: number) {
        return serviceClient.authGet<MonitoramentoRow>(`/api/v1/integracao-monitoramento/${id}`)
    }

    async fetchMonitoramentos() {
        return serviceClient.authGet<MonitoramentoRow[]>(`/api/v1/integracao-monitoramento`)
    }

    async saveMonitoramento(monitoramento: MonitoramentoRow) {
        const response = await serviceClient.authPost<MonitoramentoRow>(
            '/api/v1/integracao-monitoramento',
            monitoramento
        )
        return response
    }

    async updateMonitoramento(idMonitoramento: number, monitoramento: MonitoramentoRow) {
        const response = await serviceClient.authPut<MonitoramentoRow>(
            `/api/v1/integracao-monitoramento/${idMonitoramento}`,
            monitoramento
        )
        return response
    }

    async deleteMonitoramento(idMonitoramento: number) {
        const response = await serviceClient.authDelete(`/api/v1/integracao-monitoramento/${idMonitoramento}`)
        return response
    }

    async fetchResultadosVisaoCedente(visaoCedenteId: number) {
        return serviceClient.authGet<ResultadoAnalise[]>(`/api/v1/integracao-monitoramento/resultado/${visaoCedenteId}`)
    }

    async reprocessVisaoCedente(id: number) {
        const response = await serviceClient.authPost<RetornoEnvioVisaoCedente>(
            `/api/v1/integracao-monitoramento/reprocessar/${id}`
        )
        return response
    }
}

export default IntegracaoMonitoramentoService.singleton()
